<template>
	<el-dialog  :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false"
		:title="(type?'修改':'添加')+'单位'" :visible.sync="value" width="40%">
		<el-form label-position="right" label-width="120px" size="small" ref="form" :model="form">
			<el-form-item label="单位名称">
				<el-input class="maxwidth" v-model="form.name"></el-input>
			</el-form-item>
			<el-form-item label="组织机构代码">
				<el-input class="maxwidth" v-model="form.code"></el-input>
			</el-form-item>
			<el-form-item label="所属乡镇">
				<el-select class="maxwidth" v-model="form.area" placeholder="请选择">
					<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="拥有权限">
				<el-select multiple class="maxwidth" v-model="form.roles" placeholder="请选择">
					<el-option v-for="item in types" :key="item.name" :label="item.name" :value="item.name">
					</el-option>
				</el-select>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button @click="handleClose()">取 消</el-button>
			<el-button @click="add" type="primary">确 定</el-button>
		</span>
	</el-dialog>
</template>
<script>
	export default {
		data() {
			return {
				dialogVisible: false,
				form: {
					name: "",
					area: "",
					code: "",
					roles: []
				},
				options: [],
				types: []
			}

		},

		computed: {
			org() {
				let org = window.localStorage.getItem("org");
				return JSON.parse(org);
			},
			info() {
				let info = window.localStorage.getItem("info");
				return JSON.parse(info);
			}
		},
		props: ["value", "type", "shuju"],
		methods: {
			async init(shuju) {
				this.form = shuju;
			},
			async add() {
				this.form.pre_org_id = this.org.org_id;
				this.form.token = this.info.uid;
				let ans = await axios.post(this.$url + "admin/addorg", this.form);
				if (ans.data.status == 0) {
					this.$message({
						message: ans.data.desc,
						type: 'success'
					});
					this.$emit("input", false);
					this.$parent.getdata();
				} else {
					this.$message({
						message: ans.data.desc,
						type: 'error'
					});
				}
			},
			handleClose() {
				this.$emit("input", false);
			},
			async getarea() {
				let ans = await axios.get(this.$url + "onething/area", {
					params: {
						pid: this.org.area
					}
				});
				this.options = ans.data.lists;
			},
			async gettypes() {
				let ans = await axios.get(this.$url + "admin/types", {
					params: {
						token: this.info.uid
					}
				});
				this.types = ans.data;

			},
		},
		created() {
			this.getarea();
			this.gettypes();
		}
	}
</script>

<style>
	.maxwidth {
		max-width: 250px
	}
</style>
